import { Alert, Link, Span } from "@fluidattacks/design";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

const CONTACT_US_URL =
  "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0ZSgVbAJh3yuV0KUzBLjrZbKxVHhflbXO6a-vPRXtgmbhKphQHUCGPK4lLeKMb48zJl0HSwu7K";

const Banner = (): JSX.Element => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Alert closable={true} mb={1.25} variant={"info"}>
      {t("organization.tabs.groups.vulnerabilities.banner")}
      <Link color={theme.palette.info[700]} href={CONTACT_US_URL}>
        <Span fontWeight={"bold"} size={"md"}>
          {t("organization.tabs.groups.vulnerabilities.contact")}
        </Span>
      </Link>
    </Alert>
  );
};

export { Banner };
